<template>
  <AppSelect
    v-model="status"
    append-inner-icon="mdi:passport"
    :label="$tt('extra_nationality.has')"
    :items="items"
    :rules="[required]"
  />
</template>

<script setup lang="ts">
import { toSelectItems } from '~/helpers/general';
import type { ExtraNationality, SelectItem } from '~/types';

const status = defineModel<ExtraNationality['status']>({ required: true });
const props = defineProps<{
  hasPast?: boolean;
}>();

const { tt } = useLocalization();
const { required } = useValidation();

const statuses: Record<ExtraNationality['status'], string> = {
  none: tt('extra_nationality.none'),
  past: tt('extra_nationality.past'),
  present: tt('extra_nationality.present')
};

const items = props.hasPast ? toSelectItems(statuses) : toSelectItems(statuses).filter(nonPast);

function nonPast(item: SelectItem) {
  return item.value != 'past';
}
</script>